import React from "react"

const SkillCard = ({ skill: { icon, title, description, technologies } }) => {
	return (
		<div className="col col-12 col-md-12 col-lg-4 col-xl-4">
			<div className="bCard">
				<img src={icon} alt="front-end" />
				<h4>{title}</h4>
				<p>{description}</p>
				<span className="title">Technologies </span>
				<div className="list">
					{technologies.map((tech, index) => (
						<p className="item" key={index}>
							{tech}
						</p>
					))}
				</div>
			</div>
		</div>
	)
}

export default SkillCard
